import { SidenavBaseFilterComponent } from '../../../../../core/base/components/sidenav/base-filter/sidenav-base-filter.component';
import { BUILDING_FILTER_SCHEMA } from './building-filter.schema';
import { AutocompleteService } from '../../../../../core/services/scroll.service';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BuildingService } from '../../building/building.service';
import { SupplierService } from '../../supplier/supplier.service';
import { EstablishmentService } from '../../establishment/establishment.service';
import { MetrikTypeHoldingService } from '../../../settings/metrik-type-holding/metrik-type-holding.service';
import { LeaseTypeService } from '../../../settings/lease-type/lease-type.service';

@Component({
  selector: 'building-filter',
  templateUrl: './building-filter.component.html',
  styleUrls: ['./building-filter.component.scss'],
})
export class BuildingFilterComponent extends SidenavBaseFilterComponent {
  override readonly schema = BUILDING_FILTER_SCHEMA;

  // Mêmes référentiels que le formulaire bâtiment (types de détention actifs, fournisseurs, types de bail actifs)
  private readonly activeOnly = { isActive: true, isArchive: false, isDelete: false };

  constructor(
    public buildingService: BuildingService,
    public suppliersService: SupplierService,
    public establishmentService: EstablishmentService,
    public metrikTypeHoldingService: MetrikTypeHoldingService,
    public leaseTypeService: LeaseTypeService,
    public autocompleteService: AutocompleteService,
    public snackbarService: SnackbarService,
  ) {
    super(snackbarService, autocompleteService);

    this.addForm(
      'standardForm',
      new UntypedFormGroup({
        mainCity: new UntypedFormControl(),
        label: new UntypedFormControl(),
        detentionType: new UntypedFormControl(),
        supplier: new UntypedFormControl(),
        leaseType: new UntypedFormControl(),
        establishments: new UntypedFormControl(),
      }),
    );
  }

  initialize(): void {
    this.autocompleteMainCity('');
    this.autocompleteDetentionType('');
    this.autocompleteSupplier('');
    this.autocompleteLeaseType('');
    this.autocompleteEstablishment('');
  }

  autocompleteMainCity(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'mainCity', 'mainCity', pageToGo, () =>
        this.buildingService.findMainCities(1, 'all', search),
      )
      ?.subscribe();
  }

  autocompleteDetentionType(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'detentionType', '_id', pageToGo, (page, size) =>
        this.metrikTypeHoldingService.findAll(page, size, 'label', 'asc', search, this.activeOnly),
      )
      ?.subscribe();
  }

  autocompleteSupplier(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'supplier', '_id', pageToGo, (page, size) =>
        this.suppliersService.findAll(page, size, 'label', 'asc', search),
      )
      ?.subscribe();
  }

  autocompleteLeaseType(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'leaseType', '_id', pageToGo, (page, size) =>
        this.leaseTypeService.findAll(page, size, 'label', 'asc', search, this.activeOnly),
      )
      ?.subscribe();
  }

  autocompleteEstablishment(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'establishments', '_id', pageToGo, (page, size) =>
        this.establishmentService.findAll(page, size, 'label', 'asc', search, { onlyMine: true }),
      )
      ?.subscribe();
  }

  onScrollLine(pageToGo: 'next' | 'previous', filterField: string): void {
    switch (filterField) {
      case 'mainCity':
        this.autocompleteMainCity('', pageToGo);
        break;
      case 'detentionType':
        this.autocompleteDetentionType('', pageToGo);
        break;
      case 'supplier':
        this.autocompleteSupplier('', pageToGo);
        break;
      case 'leaseType':
        this.autocompleteLeaseType('', pageToGo);
        break;
      case 'establishments':
        this.autocompleteEstablishment('', pageToGo);
        break;
      default:
        console.error('Unknown filterField:', filterField);
    }
  }
}
